/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import Flickity from "flickity";
import gsap from "gsap";

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggles = document.querySelectorAll('.toggle-menu');
    if( toggles ) {
      toggles.forEach(toggle => {
        toggle.addEventListener('click', e => {
          e.preventDefault();

          HTML.classList.toggle('open-menu')
        })
      })
    }

    /** Select redirect */
    const selects = document.querySelectorAll(".select-redirect");
    if (selects) {
      selects.forEach((select) => {
        select.addEventListener("change", (e) => {
          window.location.href = select.value;
        });
      });
    }

    this.cart();
    this.animationLogo();
    this.sidebar();
    this.checkButton();
    this.carouselText();
    this.anchor();
    this.sticky();
    this.productGallery();
    this.quantity();
    this.inViewport();
  }

  animationLogo() {
    const elts = document.querySelectorAll('.animation-logo');

    if( elts ) {
      elts.forEach(el => {
        const mainLogo = document.querySelector('.main-logo')
        const logo = el.querySelector('.icon');
        let boundLogo = mainLogo.getBoundingClientRect();
        let bounding = el.getBoundingClientRect();
        let max = bounding.y - boundLogo.y;
        let width = bounding.width - boundLogo.width;

        gsap.set(
          logo, {
            position: 'fixed', 
            top: bounding.y,
            width : bounding.width,
            height : bounding.height,
          }
        );

        gsap.to(el, {
          autoAlpha: 1,
          duration: 0.3
        })

        window.addEventListener('scroll', () => {
          boundLogo = mainLogo.getBoundingClientRect();
          bounding = el.getBoundingClientRect();

          if( bounding.y > boundLogo.y) {
            gsap.set(logo, {
              top: bounding.y,
              width: `${bounding.width - ( width  * window.scrollY / max)}px`
            })
          } else {
            gsap.set(logo, {
              top: boundLogo.y,
              width: `${boundLogo.width}px`
            })
          }

        })

      })
    }
  }

  sidebar() {
    const triggers = document.querySelectorAll('[data-sidebar]');
    if( triggers ) {
      triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          const target = document.querySelector(`#${trigger.dataset.sidebar}`);

          if( target ) {
            target.classList.add('show');
            HTML.classList.add('open-sidebar');

            const close = target.querySelector('.trigger-sidebar');
            if( close ) {
              close.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                target.classList.remove('show');
                HTML.classList.remove('open-sidebar');
              })
            }
          }
        })
      })
    }
  }

  checkButton() {
    const elts = document.querySelectorAll('.btn, .button');

    if( elts ) {
      elts.forEach(el => {
        if( !el.querySelector('span') ) {
          el.innerHTML = '<span>' + el.innerHTML + '</span>';
        }
      })
    }
  }

  cart() {
    const triggers = document.querySelectorAll('.trigger-cart[href="#"]');

    if( triggers ) {
      triggers.forEach(trigger => {
        trigger.addEventListener('click', e => {
          e.preventDefault();
          HTML.classList.toggle('open-mini-cart');
        })
      })
    }
  }

  carouselText() {
    const carousels = document.querySelectorAll('.carousel-text');

    if( carousels ) {
      carousels.forEach(carousel => {

        let current = -1;
        const parent = carousel.closest('section');
        let imgs = false;
        let containerImgs = false;
        if( parent ) {
          containerImgs = parent.querySelector('.carousel-text__imgs');
          imgs = containerImgs.querySelectorAll('img');
        }

        // Duplicate
        const items = carousel.querySelectorAll('.item');
        if( items && window.innerWidth >= 768) {
          items.forEach((item,i) => {
            carousel.append(item.cloneNode(true));

            if( imgs ) {
              containerImgs.append(imgs[i].cloneNode(true));
              this.lazyload.update()
            }
          })
        }

        imgs = containerImgs.querySelectorAll('img');

        new Flickity(carousel, {
          cellSelector: '.item',
          wrapAround : true,
          cellAlign: 'center',
          adaptiveHeight: true,
          selectedAttraction: 0.01,
          friction: 0.2,
          on : {
            ready : function() {

            },
            select: (index) => {

              if( imgs ) {
                let delay = 0;
                if( imgs[current] ) {
                  gsap.to(imgs[current], {
                    autoAlpha: 0,
                    duration: 0.3,
                    y: '-1.5rem',
                    delay
                  })
                  delay = 0.15;
                }

                gsap.fromTo(imgs[index], {
                    autoAlpha : 0,
                    y: '1.5rem'
                  },{
                  autoAlpha: 1,
                  y: '0rem',
                  duration: 0.3,
                  delay
                })
              }

              current = index;
            }
          }
        })
      })
    }
  }

  anchor() {
    /** ANCHOR */
    const anchors = document.querySelectorAll(
      'a[href^="#"]:not([href="#"]), a[href^="/#"]:not([href="#"])'
    );

    if (anchors) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          const target = document.querySelector(
            anchor.getAttribute("href").replace("/#", "#")
          );

          if (target) {
            e.preventDefault();
            let offset = 0;
            const bound = target.getBoundingClientRect();

            gsap.to(document.querySelectorAll("html, body"), {
              duration: 0.8,
              scrollTop: window.scrollY + bound.y - offset,
              ease: "expo.out",
            });
          }
        });
      });
    }
  }

  sticky() {
    const elts = document.querySelectorAll('[data-sticky]');

    if( elts ) {
      elts.forEach(el => {
        const container = document.querySelector(el.dataset.sticky);
        const trigger = container.querySelector(el.dataset.stickyTrigger);

        if( container ) {
          const header = document.querySelector('.main-header');
          const offset = header ? header.offsetHeight : 0;

          window.addEventListener('scroll', () => {
            let bound = container.getBoundingClientRect();
            let start = bound.y;
            const end = bound.bottom;
            if( trigger ) {
              const boundT = trigger.getBoundingClientRect();
              start = boundT.bottom;
            }

            if( start <= offset && end > offset ) {
              el.classList.add('show')
            } else {
              el.classList.remove('show')
            }
          })
          window.dispatchEvent(new Event('scroll'))
        }
      })
    }
  }

  productGallery() {
    const elts = document.querySelectorAll('.product-gallery');

    if( elts ) {
      elts.forEach(el => {
        const mainImg = el.querySelector('.main-img figure img');
        const thumbs = el.querySelectorAll('.thumbs a');

        if( mainImg && thumbs ) {
          let current = 0;

          thumbs.forEach((thumb, i) => {
            thumb.addEventListener('click', e => {
              e.preventDefault();

              if( i == current ) return false;

              thumbs[current].classList.remove('active');
              thumbs[i].classList.add('active');

              const img = new Image();
              img.src = thumb.dataset.gallery;

              img.onload = () => {
                mainImg.src = img.src;
              }

              current = i;
            })
          })
        }
      })
    }
  }

  quantity() {
    const elts = document.querySelectorAll('.quantity');

    if( elts ) {
      elts.forEach(el => {
        const triggers = el.querySelectorAll('a');
        const input = el.querySelector('input');
        const btnUpdate = document.querySelector('[name="update_cart"]');

        if( triggers && input ) {
          const miniCart = el.closest('.mini-cart');
          triggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
              e.preventDefault();
              const val = input.value;
              
              
              let next = parseInt(val) <= 1 ? 1 : parseInt(val) - 1;
              if( trigger.classList.contains('more') ) {
                next = parseInt(val) + 1;
              }

              input.value = next;
              input.dispatchEvent(new Event('change'));

              if( btnUpdate ) {
                btnUpdate.removeAttribute('disabled')
              }
            })
          })

          if( miniCart) {
            input.addEventListener('change', async () => {
              const item = input.closest('.woocommerce-mini-cart-item ');

              const data = {
                action: "nc_qty_update",
                key: item.dataset.key,
                number: parseFloat(input.value),
                security: nc_obj.nonce
              }

              const res = await fetch(nc_obj.ajax_url, {
                method : 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body : (new URLSearchParams(data)).toString(),
              })
              const output = await res.json();

              /** Update mini cart */
              const priceItem = item.querySelector('.price');
              if( priceItem ) {
                priceItem.innerHTML = output.item_price
              }
              const totalCart = miniCart.querySelector('.total .amount');
              if( totalCart ) {
                totalCart.innerHTML = output.total;
              }
              const badge = document.querySelector('.trigger-cart .badge')
              if( badge ) {
                badge.innerHTML = output.count;
              }

              // console.log(output)
            })
          }
        }
      })
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
